import { Gear } from "./gear.model";

/**
 * Extension from the Gear class
 */
export class LonglineGear extends Gear {
    
    skateLength!: number;

    hookSize!: number;

    hookSpacing!: number;

    numHooksPerSkateTub!: number;

    //totalNumLostSkatesTubs!: number;

    isFloatingLongline: boolean = false;


    static transformAnonymous(anon: any): LonglineGear {
        let line = new LonglineGear();
        line.gearID = anon.gearID
        line.fishingEventID = anon.fishingEventID
        line.identifier = anon.identifier
        line.type = anon.type
        line.gearSubtype = anon.gearSubtype
        line.skateLength = anon.skateLength;
        line.hookSize = anon.hookSize;
        line.hookSpacing = anon.hookSpacing;
        line.numHooksPerSkateTub = anon.numHooksPerSkateTub;
        //line.totalNumLostSkatesTubs = anon.totalNumLostSkatesTubs;
        line.isFloatingLongline = anon.isFloatingLongline;
        line.fishery = 'Groundfish';
        return line;
    }


    constructor() {
        super();
        this.type = "Longline";
    }


    //Compares all fields except IDs and identifier
    isEqual(cmp: LonglineGear) {
        return this.identifier == cmp.identifier && 
        this.skateLength == cmp.skateLength &&
        this.hookSize == cmp.hookSize &&
        this.hookSpacing == cmp.hookSpacing &&
        this.numHooksPerSkateTub == cmp.numHooksPerSkateTub &&
        this.isFloatingLongline == cmp.isFloatingLongline &&
        this.gearSubtype.id == cmp.gearSubtype.id &&
        this.gearSubtype.lookupType == cmp.gearSubtype.lookupType;
    }


    toString() {
        if (this.identifier == '')
            return '';
        return this.identifier + " -- Longline -- " + this.gearSubtype.name + " -- " + this.skateLength + " ft -- " + this.numHooksPerSkateTub + " hooks";
    }
}